import { formatText } from 'core/i18n';

const getJointHoldersFormattedAccountType = accountType => {
    let formattedAccountType = {
        titular: 'jointHolderAccountType-titular',
        cotitular: 'jointHolderAccountType-jointHolder',
        autorizado: 'jointHolderAccountType-authorized',
    };

    return formattedAccountType[accountType] && formatText(formattedAccountType[accountType]);
};

const getJointHolderByNumberId = (userProfile, numberId) => {
    const docNumber = userProfile[`jointholder_${numberId}_docNumber`];
    if (!docNumber) {
        return;
    }
    const name = userProfile[`jointholder_${numberId}_name`];
    const lastName = userProfile[`jointholder_${numberId}_lastName`];
    const secondLastName = userProfile[`jointholder_${numberId}_secondLastName`];
    const accountType = userProfile[`jointholder_${numberId}_accountType`];

    return {
        fullName: `${name} ${lastName} ${secondLastName || ''}`,
        name,
        lastName,
        secondLastName,
        key: `jointholder_${numberId}_view`,
        accountType,
        formattedAccountType: getJointHoldersFormattedAccountType(accountType),
        documentType: userProfile[`jointholder_${numberId}_documentType`],
        docNumber,
        email: userProfile[`jointholder_${numberId}_email`],
        openDebitCard: userProfile[`jointholder_${numberId}_openDebitCard`],
    };
};

const getAllJointHolders = userProfile => {
    const jointHoldersArray = [];
    if (!userProfile?.jointHolderCount?.length) {
        return jointHoldersArray;
    }
    userProfile?.jointHolderCount.forEach(numberId => {
        const jointHolder = getJointHolderByNumberId(userProfile, numberId);
        if (jointHolder) {
            jointHoldersArray.push(jointHolder);
        }
    });
    return jointHoldersArray;
};

export { getJointHolderByNumberId, getAllJointHolders, getJointHoldersFormattedAccountType };
